import { z } from "zod";
import { NormalizedScoreSchema } from "./normalized-value.schemas.js";

const INTRO_ORIGIN_VALUES = {
  DIRECT_REQUEST: "direct_request",

  EVENT_GROUPING: "event_grouping",

  HOST_FACILITATED: "host_facilitated",

  AGENT_SUGGESTED: "agent_suggested",
} as const;

export const IntroOriginSchema = z.enum(INTRO_ORIGIN_VALUES);

export type IntroOrigin = z.infer<typeof IntroOriginSchema>;

export const IntroOrigin = {
  ...INTRO_ORIGIN_VALUES,

  isDirectRequest: (
    data: IntroOriginDataType,
  ): data is DirectRequestOriginData =>
    data.type === INTRO_ORIGIN_VALUES.DIRECT_REQUEST,

  isEventGrouping: (
    data: IntroOriginDataType,
  ): data is EventGroupingOriginData =>
    data.type === INTRO_ORIGIN_VALUES.EVENT_GROUPING,

  isHostFacilitated: (
    data: IntroOriginDataType,
  ): data is HostFacilitatedOriginData =>
    data.type === INTRO_ORIGIN_VALUES.HOST_FACILITATED,

  isAgentSuggested: (
    data: IntroOriginDataType,
  ): data is AgentSuggestedOriginData =>
    data.type === INTRO_ORIGIN_VALUES.AGENT_SUGGESTED,
} as const;

export const DirectRequestOriginDataSchema = z.object({
  type: z.literal(INTRO_ORIGIN_VALUES.DIRECT_REQUEST),
  requestedFromDirectory: z.boolean(),
});
export type DirectRequestOriginData = z.infer<
  typeof DirectRequestOriginDataSchema
>;

export const EventGroupingOriginDataSchema = z.object({
  type: z.literal(INTRO_ORIGIN_VALUES.EVENT_GROUPING),
  eventGroupingIdPublic: z.string(),
  matchScore: NormalizedScoreSchema,
  matchReasons: z.array(z.string()).readonly(),
});
export type EventGroupingOriginData = z.infer<
  typeof EventGroupingOriginDataSchema
>;

export const HostFacilitatedOriginDataSchema = z.object({
  type: z.literal(INTRO_ORIGIN_VALUES.HOST_FACILITATED),
  facilitatorUserIdPublic: z.string(),
  reason: z.string().nullable(),
});
export type HostFacilitatedOriginData = z.infer<
  typeof HostFacilitatedOriginDataSchema
>;

export const AgentSuggestedOriginDataSchema = z.object({
  type: z.literal(INTRO_ORIGIN_VALUES.AGENT_SUGGESTED),
  agentId: z.string(),
  suggestionScore: NormalizedScoreSchema,
  suggestionReasons: z.array(z.string()).readonly(),
});
export type AgentSuggestedOriginData = z.infer<
  typeof AgentSuggestedOriginDataSchema
>;

export const IntroOriginDataSchema = z.discriminatedUnion("type", [
  DirectRequestOriginDataSchema,
  EventGroupingOriginDataSchema,
  HostFacilitatedOriginDataSchema,
  AgentSuggestedOriginDataSchema,
]);
export type IntroOriginDataType = z.infer<typeof IntroOriginDataSchema>;
